"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.specificEnthalpyConversions = specificEnthalpyConversions;
const calculations_1 = require("@munters/calculations");
function specificEnthalpyConversions(fromAmount, to, conversionParameters) {
    const pressureAmount = conversionParameters.pressure;
    const temperatureAmount = conversionParameters.temperature;
    switch (to) {
        case "RelativeHumidity": {
            return calculations_1.Physics.RP1485.AmountConversions.specificEnthalpyToRelativeHumidity(pressureAmount, temperatureAmount, fromAmount);
        }
        case "HumidityRatio": {
            return calculations_1.Physics.RP1485.AmountConversions.specificEnthalpyToHumidityRatio(pressureAmount, temperatureAmount, fromAmount);
        }
        case "DewPointTemperature": {
            return calculations_1.Physics.RP1485.AmountConversions.specificEnthalpyToDewPointTemperature(pressureAmount, temperatureAmount, fromAmount);
        }
        case "WetTemperature": {
            return calculations_1.Physics.RP1485.AmountConversions.specificEnthalpyToWetTemperature(pressureAmount, temperatureAmount, fromAmount);
        }
        default: {
            throw new Error(`Can't convert ${fromAmount.unit.quantity} to ${to}`);
        }
    }
}
//# sourceMappingURL=specific-enthalpy-conversions.js.map